import { useEffect } from 'react'
import queryString from 'query-string'

export const useUrlParams = (steps, scrollToStep) => {
  useEffect(() => {
    const resolveInitialStep = () => {
      try {
        const query = queryString.parse(window.location.search)
        if (!query) return null

        if (query.stepId) {
          let position = steps.findIndex(s => s.id === query.stepId)
          if (position < 0) {
            console.log(
              '⚠️ LOG: stepId incorrect on query params. defaulting to first step',
            )
          }
          // Intentional mutation: sets a flag on the step so Step4 skips
          // the start-screen animation when deep-linking directly to this step.
          if (position >= 0) steps[position].startScreenDisabled = true
          position = position + 1 // +1 converts 0-based findIndex to 1-based step.position
          console.log(
            `⚠️ LOG: found stepId in params. that step position is: ${position}`,
          )
          return { position, stepId: query.stepId }
        }

        if (query.submissionId) {
          console.log('⚠️ LOG: found submission id. hiding start screen')
          const receiptStep = steps.find(s => s.type === 'RECEIPT_VERIFICATION')
          if (!receiptStep) return null

          let position = steps.findIndex(s => s.id === receiptStep.id)
          if (position >= 0) steps[position].startScreenDisabled = true
          position = position + 1 // +1 for start step
          console.log(
            `⚠️ LOG: found submissionId in params. that step position is: ${position}`,
          )
          return { position, stepId: receiptStep.id }
        }

        console.log('⚠️ LOG: No stepId or submissionId in query params')
        return null
      } catch (e) {
        return null
      }
    }

    const result = resolveInitialStep()
    if (result && result.position > 0) {
      console.log(
        `Query string gave us the info we need to tell us we should scroll to step ${result.position}`,
      )
      // Defer scroll until the document height stabilizes. getBreakStatus
      // resolves async and unlocks completed steps, which expand from the
      // small LockedStep render into full content — growing the doc by
      // hundreds/thousands of pixels and drifting the smooth-scroll target.
      // Wait for height to be quiet for ~300ms (or 2s hard cap) before scrolling.
      let lastHeight = document.documentElement.scrollHeight
      let quietFrames = 0
      let elapsed = 0
      const waitForStableHeight = () => {
        elapsed += 1
        const currentHeight = document.documentElement.scrollHeight
        if (currentHeight === lastHeight) {
          quietFrames += 1
        } else {
          quietFrames = 0
          lastHeight = currentHeight
        }
        if (quietFrames >= 18 || elapsed >= 120) {
          scrollToStep(result.position, result.stepId)
          return
        }
        requestAnimationFrame(waitForStableHeight)
      }
      requestAnimationFrame(waitForStableHeight)
    } else {
      console.log('⚠️ LOG: No query string detected, not scrolling to step')
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
}
